import { bridge } from '@changba/funny';
export var props = {
  theme: {
    type: String,
    required: false,
    default: 'light'
  },
  circle: {
    type: Boolean,
    required: false,
    default: false
  },
  disabledShare: {
    type: Boolean,
    required: false
  },
  shareParams: {
    type: Object,
    required: false,
    default: () => ({})
  },
  onBack: {
    type: Function,
    default: () => {
      bridge.closePage();
    }
  }
};